export const GET_STRUCTURE = 'GET_STRUCTURE';
export const STRUCTURE_UPDATED = 'STRUCTURE_UPDATED';
export const INVALID_TOKEN = 'INVALID_TOKEN';